import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "registration-wrap registration-wrap--variant_role" }
const _hoisted_2 = { class: "registration-wrap__content" }
const _hoisted_3 = { class: "registration-form" }
const _hoisted_4 = { class: "registration-form__prehead reg-prehead" }
const _hoisted_5 = { class: "reg-prehead__back-wrap" }
const _hoisted_6 = { class: "reg-prehead__text" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "reg-prehead__text" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["alt", "title"]
const _hoisted_11 = { class: "registration-form__head" }
const _hoisted_12 = { class: "registration-form__title" }
const _hoisted_13 = { class: "registration-form__link-wrap" }
const _hoisted_14 = { class: "registration-form__text" }
const _hoisted_15 = { class: "registration-form__content" }
const _hoisted_16 = { class: "registration-form__tabs" }
const _hoisted_17 = { class: "registration-form__role-text mo-space_mb mo-space_mb--3" }
const _hoisted_18 = {
  class: "reg-tabs",
  role: "tablist"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "g-row g-row--align_center g-row--appearance_spaced g-row--space_lg-lg g-row--space_xl-xl mo-space_mt mo-space_mt--5" }
const _hoisted_21 = { class: "g-cell g-cols g-cols--12 mo-space_mt mo-space_mt--5 mo-space_mt--8-lg" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "mo-button__text" }
const _hoisted_24 = { class: "g-cell g-cols g-cols--12 mo-space_mt mo-space_mt--5 mo-space_mt--8-lg" }
const _hoisted_25 = { class: "ds-caption ds-caption--size_sm ds-caption--size_md-xl ds-caption--color_text_11 ds-caption--medium" }
const _hoisted_26 = { class: "registration-wrap__figure" }
const _hoisted_27 = ["srcset"]
const _hoisted_28 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (1 === $setup.currentStep)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "reg-prehead__back",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.resetRoleSelection()))
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("svg", {
                    class: "reg-prehead__icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "15",
                    height: "24",
                    viewBox: "0 0 15 24",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M7 18L1 12L7 6",
                      stroke: "black",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("Return to role selection")), 1)
                ]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "reg-prehead__back",
                  href: $setup.index_url
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    class: "reg-prehead__icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "15",
                    height: "24",
                    viewBox: "0 0 15 24",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M7 18L1 12L7 6",
                      stroke: "black",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("Back to site")), 1)
                ], 8, _hoisted_7))
          ]),
          _createElementVNode("a", {
            class: "registration-form__logo",
            href: $setup.index_url
          }, [
            _createElementVNode("img", {
              class: "logo-img",
              src: "/static/img/auth-logo.svg",
              alt: _ctx.$t('Berrdo'),
              title: _ctx.$t('Berrdo'),
              fetchpriority: "high",
              loading: "eager"
            }, null, 8, _hoisted_10)
          ], 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.$t("Congratulations!")), 1),
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(1 === $setup.currentStep ? _ctx.currentSubtitle : _ctx.$t("You have started registration as a partner")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          ($setup.currentStep === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("Choose a role:")), 1),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.roles, (role, key, i) => {
                      return (_openBlock(), _createElementBlock("button", {
                        class: _normalizeClass(["reg-tabs__tab", { 'is-active': $setup.currentUserType == key}]),
                        role: "tab",
                        "active-class": "is-active",
                        onClick: ($event: any) => ($setup.onChangeRole(key))
                      }, _toDisplayString(role.label), 11, _hoisted_19))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "mo-button mo-button--variant_primary mo-button--slim",
                      type: "submit",
                      disabled: $setup.isLoad,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.confirmRole()), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('Confirm')), 1)
                    ], 8, _hoisted_22)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("*Select a role to continue setting up your profile.")), 1)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          ($setup.currentStep === 1)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.RolesMap[$setup.currentUserType].formComponent), {
                key: 1,
                currentUserType: $setup.currentUserType
              }, null, 8, ["currentUserType"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("picture", null, [
        _createElementVNode("source", {
          type: "image/webp",
          srcset: $setup.img_map[$setup.currentStep].webp
        }, null, 8, _hoisted_27),
        _createElementVNode("img", {
          class: "registration-wrap__media",
          src: $setup.img_map[$setup.currentStep].img,
          alt: _ctx.$t('Berrdo registration image alt'),
          fetchpriority: "high",
          loading: "eager"
        }, null, 8, _hoisted_28)
      ])
    ])
  ]))
}